import React from 'react';
import DatePicker from 'react-datepicker';
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
    Button,
} from 'reactstrap';
import { Icon, RSelect } from '../../../../components/Component';
import { newRoles, LeadStatus, LeadLabels } from '../../../../utils/envConfig';
import ChannelPartnersFilter from '../../filter-components/ChannelPartnersFilter';

const LeadsListFilterBar = ({
    authuser,
    // New Leads Sort
    newLeadsSort,
    onNewLeadsSortToggle,
    // Status Filter
    statusGet,
    filterStatus,
    onStatusChange,
    // Role Filter
    roleGet,
    filterRole,
    onRoleChange,
    allowedRoles,
    // Label Filter
    leadsLabelGetOption,
    temporaryLabel,
    filterLeadLabel,
    onLabelChange,
    // Lead Source Filter
    optLeadSource,
    selectedLeadSourceOptions, // Renamed to avoid conflict
    onLeadSourceChange,
    CustomMultiValueLabel, // Pass this down if used by RSelect for LeadSource
    // Tag Filter
    allTags,
    selectedFilterTags,
    onTagsChange,
    // Channel Partner Filter
    selectedChannelPartners,
    onChannelPartnersChange,
    // Lead Status Filter
    leadLastStatusGet,
    currentFilterLeadStatus, // Renamed to avoid conflict
    onLeadStatusChange,
    // Agent Filter
    optAgents,
    leadsAgentGetObj,
    selectedAgent,
    onAgentChange,
    // Date Range Filter
    startDateGet,
    rangeStart,
    onRangeStartChange,
    endDateGet,
    rangeEnd,
    onRangeEndChange,
    viewMode = "default",
}) => {
    const isChannelPartnerManager = authuser?.role && [newRoles.ChannelPartnerManager].includes(authuser?.role);
    const isChannelPartnerAgent = authuser?.role && [newRoles.ChannelPartnerAgent].includes(authuser?.role);

    return (
        <div className="d-flex justify-content-end float-end">
            <div className="d-flex justify-content-end ">
                <ul className="nk-block-tools d-flex flex-wrap gx-1 gy-2 justify-content-end w-75">

                    <li style={{ listStyleType: 'none' }}>
                        <Button
                            key={`button-option`}
                            className={`mx-2 border`}
                            onClick={onNewLeadsSortToggle}
                            color={newLeadsSort === true ? 'primary' : 'white'}
                        >
                            <div className="d-flex" style={{ gap: '0.5rem' }}>
                                <small>
                                    <Icon name={newLeadsSort === true ? 'check-c' : 'square-c'} />
                                </small>
                                New
                            </div>
                        </Button>
                    </li>
                    {isChannelPartnerManager || isChannelPartnerAgent ? null : <li style={{ listStyleType: 'none' }}>
                        <UncontrolledDropdown>
                            <DropdownToggle
                                color="transparent"
                                className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                            >
                                {statusGet ? statusGet : filterStatus ? filterStatus : 'Active'}
                            </DropdownToggle>
                            <DropdownMenu start>
                                <ul className="link-list-opt no-bdr">
                                    <li>
                                        <DropdownItem onClick={() => onStatusChange('Active')}>
                                            <span>Active</span>
                                        </DropdownItem>
                                    </li>
                                    {/* Assuming 'Inactive' or other statuses might be added later */}
                                    <li>
                                        <DropdownItem onClick={() => onStatusChange('Inactive')}>
                                            <span>Inactive</span>
                                        </DropdownItem>
                                    </li>
                                    <li>
                                        <DropdownItem onClick={() => onStatusChange('')}>
                                            <span>All</span>
                                        </DropdownItem>
                                    </li>
                                </ul>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </li>}
                    {isChannelPartnerManager || isChannelPartnerAgent ? null : <li style={{ listStyleType: 'none' }}>
                        <UncontrolledDropdown>
                            <DropdownToggle
                                color="transparent"
                                className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                            >
                                <Icon name="users" />{' '}
                                <span>
                                    {roleGet !== 'null' && roleGet !== '' && roleGet !== null
                                        ? roleGet
                                        : filterRole
                                            ? filterRole
                                            : 'Select Role'}
                                </span>
                            </DropdownToggle>
                            <DropdownMenu start>
                                <ul className="link-list-opt no-bdr">
                                    {(roleGet || filterRole) && (
                                        <li>
                                            <DropdownItem
                                                onClick={(ev) => {
                                                    onRoleChange('');
                                                }}
                                            >
                                                <span>All</span>
                                            </DropdownItem>
                                        </li>
                                    )}
                                    {Object.keys(newRoles)
                                        .filter((roleKey) => allowedRoles.includes(newRoles[roleKey]))
                                        .map((roleKey, index) => (
                                            <li key={index + newRoles[roleKey]}>
                                                <DropdownItem onClick={() => onRoleChange(newRoles[roleKey])}>
                                                    <span>{newRoles[roleKey]}</span>
                                                </DropdownItem>
                                            </li>
                                        ))}
                                </ul>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </li>}
                    {viewMode !== "channelPartner" && !isChannelPartnerManager && !isChannelPartnerAgent && (
                        <>
                            <li style={{ listStyleType: 'none' }}>
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        color="transparent"
                                        className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                                    >
                                        {leadsLabelGetOption ||
                                            temporaryLabel ||
                                            filterLeadLabel ||
                                            'Filter by Label'}
                                    </DropdownToggle>
                                    <DropdownMenu start>
                                        <ul className="link-list-opt no-bdr">
                                            {(leadsLabelGetOption || filterLeadLabel) && (
                                                <li>
                                                    <DropdownItem
                                                        onClick={(ev) => {
                                                            onLabelChange(''); // Clears label and associated lead sources
                                                        }}
                                                    >
                                                        <span>All</span>
                                                    </DropdownItem>
                                                </li>
                                            )}
                                            {Object.keys(LeadLabels).map((label) => (
                                                <li key={label}>
                                                    <DropdownItem onClick={() => onLabelChange(label)}>
                                                        <span>{LeadLabels[label]}</span>
                                                    </DropdownItem>
                                                </li>
                                            ))}
                                        </ul>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </li>
                            {isChannelPartnerManager || isChannelPartnerAgent ? null :<li>
                                {optLeadSource && (
                                    <div className="status-div">
                                        <RSelect
                                            placeholder="Filter By Leadsource"
                                            options={optLeadSource}
                                            isMulti
                                            value={selectedLeadSourceOptions}
                                            onChange={onLeadSourceChange}
                                            className="status-div-rselect"
                                            components={CustomMultiValueLabel ? { MultiValueLabel: CustomMultiValueLabel } : {}}
                                        />
                                    </div>
                                )}
                            </li>}
                            <li>
                                <div className="status-div">
                                    <RSelect
                                        placeholder="Filter By Tags"
                                        options={allTags}
                                        isMulti
                                        value={selectedFilterTags}
                                        onChange={onTagsChange}
                                        className="status-div-rselect"
                                    />
                                </div>
                            </li>
                        </>
                    )}
                    {isChannelPartnerManager || isChannelPartnerAgent ? null : <li>
                        <div className="status-div">
                            <ChannelPartnersFilter
                                stateVar={selectedChannelPartners}
                                onChange={onChannelPartnersChange}
                                className="status-div-rselect"
                                placeholder="Filter By Channel Partner"
                                isMulti={true}
                            />
                        </div>
                    </li>}
                    <li style={{ listStyleType: 'none' }}>
                        <UncontrolledDropdown>
                            <DropdownToggle
                                color="transparent"
                                className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                            >
                                {leadLastStatusGet
                                    ? leadLastStatusGet
                                    : currentFilterLeadStatus
                                        ? currentFilterLeadStatus
                                        : 'Filter by Lead Status'}
                            </DropdownToggle>
                            <DropdownMenu start>
                                <ul className="link-list-opt no-bdr">
                                    {(leadLastStatusGet || currentFilterLeadStatus) && (
                                        <li>
                                            <DropdownItem
                                                onClick={(ev) => {
                                                    onLeadStatusChange('');
                                                }}
                                            >
                                                <span>All</span>
                                            </DropdownItem>
                                        </li>
                                    )}
                                    {Object.keys(LeadStatus).map((status) => (
                                        <li key={status}>
                                            <DropdownItem
                                                onClick={() => onLeadStatusChange(LeadStatus[status])}
                                            >
                                                <span>{LeadStatus[status]}</span>
                                            </DropdownItem>
                                        </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </li>
                    {authuser?.role && ![newRoles.Agent, newRoles.AnonymousAgent, newRoles.ChannelPartnerAgent].includes(authuser?.role) && (
                        <li className="status-div me-1">
                            <RSelect
                                options={[
                                    { value: 'all', label: 'All Agents' }, // Changed for clarity
                                    { value: 'Unassigned', label: 'Not Assigned' },
                                    ...optAgents,
                                ]}
                                className="status-div"
                                value={
                                    leadsAgentGetObj && !selectedAgent?.value // Prefer state if available
                                        ? JSON.parse(leadsAgentGetObj)
                                        : selectedAgent?.value === 'all' || !selectedAgent?.value
                                            ? { value: 'all', label: 'All Agents' } // Default or explicit "All"
                                            : selectedAgent
                                }
                                placeholder="Filter By Agent"
                                onChange={onAgentChange}
                            />
                        </li>
                    )}
                    <li className="">
                        <div className="form-group">
                            <div className="form-control-wrap datepicker-zindex ">
                                <div className="input-daterange date-picker-range input-group datepicker-zindex ">
                                    <DatePicker
                                        selected={startDateGet ? new Date(startDateGet) : rangeStart}
                                        onChange={onRangeStartChange}
                                        selectsStart
                                        startDate={startDateGet ? new Date(startDateGet) : rangeStart}
                                        endDate={endDateGet ? new Date(endDateGet) : rangeEnd}
                                        wrapperClassName="start-m"
                                        className="form-control datepicker-zindex"
                                        placeholderText="Start Date"
                                        isClearable
                                    />{' '}
                                    <div className="input-group-addon">TO</div>
                                    <DatePicker
                                        selected={endDateGet ? new Date(endDateGet) : rangeEnd}
                                        onChange={onRangeEndChange}
                                        startDate={startDateGet ? new Date(startDateGet) : rangeStart}
                                        endDate={endDateGet ? new Date(endDateGet) : rangeEnd}
                                        selectsEnd
                                        minDate={startDateGet ? new Date(startDateGet) : rangeStart}
                                        wrapperClassName="end-m"
                                        className="form-control datepicker-zindex"
                                        placeholderText="End Date"
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default LeadsListFilterBar;